/**
 * @generated SignedSource<<8909c3178a7e3a2ece2362ad08b09e04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type FeatureKind = "EXPERIMENT" | "OPS" | "RELEASE" | "%future added value";
export type FeatureStage = "BETA" | "GA" | "INTERNAL" | "OFF" | "%future added value";
export type featureFlagsQuery$variables = Record<PropertyKey, never>;
export type featureFlagsQuery$data = {
  readonly featureFlags: ReadonlyArray<{
    readonly key: FeatureKey;
    readonly killed: boolean;
    readonly kind: FeatureKind;
    readonly percent: number;
    readonly stage: FeatureStage;
  }>;
};
export type featureFlagsQuery = {
  response: featureFlagsQuery$data;
  variables: featureFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "featureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "killed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "featureFlagsQuery",
    "selections": (v0/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "featureFlagsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "90743195660875543e61a6a7e4df8d37",
    "id": null,
    "metadata": {},
    "name": "featureFlagsQuery",
    "operationKind": "query",
    "text": "query featureFlagsQuery {\n  featureFlags {\n    key\n    stage\n    killed\n    percent\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "05a96fc27ec9541240e4809ab776abba";

export default node;
